// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import KwPanel from '../../common/KwPanel';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { useForm } from 'react-hook-form';
import ChangeStatusForm from '../components/ChangeStatusForm';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import {
  changeStatus,
  getAvailableStatusesForRequest,
} from '../../../api/requestApi';

export interface ChangeStatusProps {
  done: (d?: unknown) => void;
  cancel: () => void;
  request: { id: string };
}

function ChangeStatus({ done, cancel, request }: ChangeStatusProps) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
  } = useForm();
  const [processing, setProcessing] = useState();
  const { t } = useTranslation();

  const [statuses, setStatuses] = useState();
  useEffect(() => {
    getAvailableStatusesForRequest(request.id)
      .then((d) => {
        setStatuses(d.items.statuses);
      })
      .catch((e) => {
        console.error(e);
        toast.error(t('Statuses not found'));
      });
  }, [request.id, t]);

  const onSubmit = (data) => {
    setProcessing(true);
    changeStatus(request.id, data.statusId, data.reason)
      .then((d) => {
        toast.success(t('Request updated'));
        done(d);
        setProcessing(false);
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to update request'));
        setProcessing(false);
      });
  };

  return (
    <SlideoutLayout
      title={t('Change status')}
      cancel={cancel}
      bar={
        <Button
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          isDisabled={processing}
          title={processing ? t('Processing') : t('Change status')}
          text={t('Change status')}
        />
      }
    >
      <KwPanel className="mb-4 form-horizontal">
        {statuses && (
          <ChangeStatusForm
            request={request}
            statuses={statuses}
            register={register}
            errors={errors}
            control={control}
            getValues={getValues}
          ></ChangeStatusForm>
        )}
      </KwPanel>
    </SlideoutLayout>
  );
}

export default ChangeStatus;
